import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: Number }

  initialize() {
    this.resize = this.resize.bind(this)
  }

  connect() {
    this.submitting = false
    this.updateSubmit()
    window.addEventListener("resize", this.resize)
    this.open()
    this.resize()
    this.closeTimer = window.setTimeout(() => this.close(), this.timeoutValue)
  }

  disconnect() {
    window.removeEventListener("resize", this.resize)
    if (this.closeTimer) window.clearTimeout(this.closeTimer)
  }

  updateSubmit() {
    const submit = this.modal.querySelector(".actions input[type='submit']")
    if (submit) submit.disabled = this.submitting || !this.modal.querySelector("input[type='checkbox']:checked")
  }

  submit() {
    this.submitting = true
    this.updateSubmit()
  }

  resize() {
    const content = this.modal.querySelector(".modal-content")
    const variants = this.modal.querySelector(".variants")
    if (!content || !variants) return

    const contentStyle = getComputedStyle(content)
    const verticalPadding = this.size(contentStyle.paddingTop) + this.size(contentStyle.paddingBottom)
    const occupiedHeight = ["h1", ".text", ".actions"].reduce((height, selector) => {
      const element = this.modal.querySelector(selector)
      if (!element) return height

      const style = getComputedStyle(element)
      return height + element.offsetHeight + this.size(style.marginTop) + this.size(style.marginBottom)
    }, verticalPadding)

    variants.style.maxHeight = `calc(100vh - ${occupiedHeight}px)`
  }

  open() {
    this.dispatchModalEvent("open")
  }

  close() {
    this.dispatchModalEvent("close")
  }

  dispatchModalEvent(name) {
    this.modal.dispatchEvent(new CustomEvent(`website:modal:${name}`))
  }

  size(value) {
    return Number.parseFloat(value) || 0
  }

  get modal() {
    return this.element.closest(".modal")
  }
}
